import React, {FC, ReactNode} from 'react';
import {Button} from 'antd';
import {MainTitle} from '../../../components/mainTitle/MainTitle';
import {SoundBtn} from '@components/SoundBtn';
import {HeartFilled, HeartOutlined} from '@ant-design/icons';

export interface CommonMainTitleProps {
    title: string;
    isFavorite?: boolean;
    canToggleFavorite?: boolean;
    toggleFavorite?: () => Promise<void> | undefined;
    isSoundBtnVisible?: boolean;
}

export const CommonMainTitle: FC<CommonMainTitleProps> = ({
    title,
    isFavorite,
    canToggleFavorite,
    toggleFavorite,
    isSoundBtnVisible = true,
}) => {
    const titleItems: ReactNode[] = [];
    if (canToggleFavorite) {
        titleItems.push(
            <Button size="large" className={isFavorite ? 'active' : ''} onClick={toggleFavorite}>
                {isFavorite ? <HeartFilled></HeartFilled> : <HeartOutlined></HeartOutlined>}
            </Button>
        );
    }

    if (isSoundBtnVisible) {
        titleItems.push(<SoundBtn />);
    }

    // TODO: (Future) consider to remove this because we never pass 'isLive' prop here
    // if (isLive) {
    //     titleItems.push(<LiveTag text="Live" />);
    // }

    return <MainTitle title={title} items={titleItems} />;
};
